import { headerJs } from "./header";
import getUrlParameter from "./helpers/urlParameters";
import { storeToUrl } from "./helpers/urlParameters";

headerJs()
const nextButton = document.querySelector('#pag-next');
const prevButton = document.querySelector('#pag-prev');

function getLatestArticles(page, callback) {
  const validPage = page || 1;
  const pageSize = document.getElementById('pageSize').value;


  document.querySelector('.renderArticles').classList.add('loading');

  fetch(`/Umbraco/Surface/ArticlesList/GetLatestArticles?page=${validPage}&pageSize=${pageSize}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    }
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(result => {

      storeToUrl({ page: validPage });

      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });

      setTimeout(() => {
        // document.querySelector('.renderArticles').classList.remove('loading');
        document.querySelector('.renderArticles').innerHTML = result;

        if (callback) {
          callback();
        }
      }, 1000);
    })
    .catch(error => {
      console.error('Error:', error);
    });
}


document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    const target = e.target;


    if (target.matches('#navigationpagination a.page-link') && !target.closest('li.page-item').classList.contains('disabled')) {
      e.preventDefault();
      const requestedPage = target.dataset.pageNumber;


      getLatestArticles(requestedPage, () => {
        updatePaginationButtons();
      });
    }
  });

  getLatestArticles();
});


function updatePaginationButtons() {
  const currentPage = getUrlParameter('page');

  nextButton.disabled = currentPage >= document.querySelectorAll('#navigationpagination a.page-link').length;
  prevButton.disabled = currentPage <= 1;
}


nextButton.addEventListener("click", function (e) {
  console.log("Next btn Clicked")
  e.preventDefault()
  const currentPage = getUrlParameter('page');
  getLatestArticles(currentPage + 1);
})

prevButton.addEventListener("click", function (e) {
  console.log("PRev btn Clicked")
  e.preventDefault()
  const currentPage = getUrlParameter('page');
  getLatestArticles(currentPage - 1);
})






